import videoPlayer from "@/components/videoPlayer/videoPlayer.vue"

export default {
    components: {
        videoPlayer, 
    },

    props: {
        linksList: {
            type: Array,
            require: true,
        },
    },

    data() {
        return {
            activeDay: 1,
        }
    },

    methods: {
        nextSlide() {
            if (this.activeDay < (this.linksList.length - 2)) {
                this.activeDay++;
            }
        },
        
        prevSlide() {
            if (this.activeDay > 0) {
                this.activeDay--;
            }
        },
    },
}